module.exports = __webpack_public_path__ + "img/new_coupon_banner_mx@2x.bd9650be.png";